import React from 'react'

import { Heading } from '../../components'
import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { View } from '../../components/line-stacked-bar-chart'
import { AppPlatformLabels, AppRegionLabels } from './constants'
import { AppPlatform, AppRegion, TrafficDataViewEnum, TrafficSettings } from './types'

export function WidgetAppSettingsSection() {
  const { settings, setSettings } = useFinancialsTableContext<TrafficSettings>()

  const toggleSetting = (key: keyof TrafficSettings, value: TrafficSettings[typeof key]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  return (
    <div className="flex items-center justify-between">
      <Heading level={4} className="text-muted">
        Apps: Monthly Active Users
      </Heading>
      <div className="flex h-8 flex-row space-x-5">
        <ChipSwitch size="small" label="Platform">
          {[AppPlatform.ios, AppPlatform.android].map((key) => (
            <ChipSwitchButton
              key={key}
              active={settings.appPlatforms.includes(key)}
              onClick={() => {
                const has = settings.appPlatforms.includes(key)
                toggleSetting('appPlatforms', [
                  ...settings.appPlatforms.filter((platform) => platform !== key),
                  ...(has ? [] : [key]),
                ])
              }}
            >
              {AppPlatformLabels[key]}
            </ChipSwitchButton>
          ))}
        </ChipSwitch>

        <ChipSwitch size="small" label="Location">
          {[AppRegion.ww, AppRegion.us].map((key) => (
            <ChipSwitchButton
              key={key}
              active={settings.appRegions.includes(key)}
              onClick={() => {
                const has = settings.appRegions.includes(key)
                toggleSetting('appRegions', [
                  ...settings.appRegions.filter((platform) => platform !== key),
                  ...(has ? [] : [key]),
                ])
              }}
            >
              {AppRegionLabels[key]}
            </ChipSwitchButton>
          ))}
        </ChipSwitch>

        <ChipSwitch size="small" label="Data">
          <ChipSwitchButton
            active={settings.trafficDataView === TrafficDataViewEnum.visits}
            onClick={() => {
              toggleSetting('trafficDataView', TrafficDataViewEnum.visits)
            }}
          >
            MAU
          </ChipSwitchButton>
          <ChipSwitchButton
            active={settings.trafficDataView === TrafficDataViewEnum.momChangePct}
            onClick={() => {
              toggleSetting('trafficDataView', TrafficDataViewEnum.momChangePct)
            }}
          >
            MoM Growth %
          </ChipSwitchButton>
        </ChipSwitch>

        <ChipSwitch size="small" label="Chart">
          <ChipSwitchButton
            active={settings.chartView === View.bars}
            leftContent="chartBar"
            size="none"
            className="h-6 w-6"
            onClick={() => {
              toggleSetting('chartView', View.bars)
            }}
          />
          <ChipSwitchButton
            active={settings.chartView === View.lines}
            leftContent="lineChartType"
            size="none"
            className="h-6 w-6"
            onClick={() => {
              toggleSetting('chartView', View.lines)
            }}
          />
        </ChipSwitch>
      </div>
    </div>
  )
}
